export enum PuzzleWinTypesEnum {
  SOLUTION_WORD = 'solution-word',
  FULL_PUZZLE = 'full-puzzle',
}
